import { render } from "./TermsModal.vue?vue&type=template&id=f02353f6&scoped=true"
import script from "./TermsModal.vue?vue&type=script&lang=js"
export * from "./TermsModal.vue?vue&type=script&lang=js"

import "./TermsModal.vue?vue&type=style&index=0&id=f02353f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f02353f6"]])

export default __exports__